import React, { ReactElement } from 'react'
import Icon from '../icon'
import Image from '../../components/imgix-img'

export interface TrustpilotData {
  companyScore: {
    score: {
      trustScore: number
      stars: string
    }
    totalReviews: number
  }
}

interface TrustpilotProps {
  trustpilotData: TrustpilotData
  brand: 'money' | 'uswitch'
}

const TrustpilotAtom = ({ trustpilotData, brand }: TrustpilotProps): ReactElement => {
  return (
    <div className='trustpilotAtom'>
      {trustpilotData && (
        <div className='trustpilotAtom__text'>
          {brand === 'money' ? 'money.co.uk' : 'Uswitch.com'} is rated <span>Excellent</span> | by{' '}
          {trustpilotData.companyScore.totalReviews} people
        </div>
      )}
      {trustpilotData && (
        <div className='trustpilotAtom__logo'>
          {/* @ts-ignore */}
          <Image
            src={`https://images-static.trustpilot.com/api/stars/${trustpilotData.companyScore.score.stars}/128x24.png`}
            alt={'Trust Pilot stars'}
          />
          <Icon glyph={'trust-pilot-logo-white'} color={'#000000'} fill={'#000000'} />
        </div>
      )}
    </div>
  )
}

export default TrustpilotAtom
